//import '../../Styles/css/Day.css';
//import '../../Styles/css/Counter.css';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect,useState } from 'react';
import { useMemo } from 'react';

import useCraRdv from '../../hooks/useCraRdv';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import { isHolidayOrWeekendOrNotStartedBdc } from '../../Utils/getCalendarMonthMatrix';

export function ColorBox(counter){
    if(counter==0)
        return '#f1f1f1';
    else if(counter==1)
        return '#C3C9F1';
    else
        return '#E7EAF9';
}

export const initializeEvent = (expert,day,isAFreeDay) => {
    return {
        expert: expert,
        client: null,
        counter: 1,
        description: '',
        // label: '#f1f1f1',
        day: day.format('DD-MM-YYYY'),
        isHoliday: isAFreeDay,
        idDay: ''
    };
};

// eslint-disable-next-line no-unused-vars
const Day = ({ day, rowIdx, evts,  expert, holidaysDuMoisDuCra,dateDebutBDC,dateFinBDC,statutCra }) => {
    Day.propTypes = {
        day: PropTypes.any,
        rowIdx: PropTypes.any,
        evts: PropTypes.any,
        expert: PropTypes.any,
        holidaysDuMoisDuCra: PropTypes.any,
        dateDebutBDC: PropTypes.any,
        dateFinBDC: PropTypes.any,
        statutCra: PropTypes.any,
    };
    const {device}=useWindowSize();
    const isAFreeDay = useMemo(() => isHolidayOrWeekendOrNotStartedBdc({day: day,dateDebutBDC: dateDebutBDC,dateFinBDC:dateFinBDC, holidaysDuMoisDuCra: holidaysDuMoisDuCra }), []);
    const role = useRole();
    const { setDaySelected, setShowEventModal, setSelectedEvent } = useCraRdv();

    //========================default event===============================================
    // let initEvt = ;

    const [dayEvent, setDayEvent] = useState(initializeEvent(expert,day,isAFreeDay));

    //========================use Effect===============================================
    useEffect(() => {
        evts.map((ev) => { if (ev.day === day.format('DD-MM-YYYY')) {
            setDayEvent(ev); } });
    }, [dayEvent, evts, day, holidaysDuMoisDuCra]);

    //! LOGGING DEBUGGING
    // useEffect(() => {
    //     if(day && rowIdx && evts && expert && holidaysDuMoisDuCra && dateDebutBDC){
    //         console.log('**************');
    //         console.log({day, rowIdx, evts,  expert, holidaysDuMoisDuCra,dateDebutBDC, bDCDAY: moment(dateDebutBDC).daysInMonth()});
    //     }
    // }, [day, rowIdx, evts, expert, holidaysDuMoisDuCra,dateDebutBDC]);
    return (
        <div style={{display:'flex',gap:'8px',flexDirection: 'column'}}>
            {rowIdx === 0 && (

                <div
                    style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        background: '#FFFFFF',
                        border: '1px solid #C3C9F1',
                        borderRadius: '10px 0px 0px 0px',
                        justifyContent: 'center',
                        padding: '8px',
                    }}
                >
                    {device=='desktop' &&
                            <p
                                // className="text-sm mt-1 font-family:verdana"
                                style={{
                                    fontSize: '0.875rem',
                                    margin:0,
                                }}
                            >
                                {day.format('dddd').toUpperCase()}
                            </p>
                    }
                    {device!='desktop' &&
                            <p
                                // className="text-sm mt-1 font-family:verdana"
                                style={{
                                    fontSize: '0.875rem',
                                    margin:0,
                                }}
                            >
                                {day.format('ddd').toUpperCase()}
                            </p>
                    }
                </div>

            )}
            <div
                // className="border border-gray-300 flex flex-col"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background:'white',
                    padding: '10px',
                    minHeight:'96px',
                    // border: 'var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important',
                    border: '1px solid #C3C9F1',
                }}
            >
                <header
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                            alignSelf: 'self-end',
                            width:dayEvent?.description ?'74%' :'61%' //la position change en fonction de l'icône de description (if exist or not)
                        }}
                    >
                        <p
                            style={{
                                fontFamily: 'Lato',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                fontSize: '24px',
                                lineHeight: '28px',
                                color: '#000000',
                            }}
                        >
                            {day.format('DD')}
                        </p>
                    </div>
                    {dayEvent?.description &&
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                width: '50%',
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'flex-end',marginTop: '-30px' }}>
                                <Tooltip title={dayEvent?.description}>
                                    <InfoOutlinedIcon />
                                </Tooltip>
                            </div>
                        </div>
                    }
                </header>
                {!isAFreeDay && //! was dayEvent?.isHoliday
                    <div
                    // className="flex-1 cursor-pointer"
                        style={{
                            //flex: '1 1 0%',
                            display: 'flex',
                            justifyContent: 'center',
                            cursor: role=='expert' ??'pointer',
                            //padding:'10px',
                        }}
                    >
                        <div
                            onClick={() => setSelectedEvent(dayEvent)}
                            // className={`bg-${(isHoliday(day) ? 'gray' : dayEvent.label)}-200 p-1 mr-4 b-2 text-gray-600 text-sm rounded mb-2 truncate`}
                            style={{
                                backgroundColor:ColorBox(dayEvent?.counter),
                                width: '40px',
                                height: '30px',
                                border: '1px solid #214DCE',
                                borderRadius: '10px',
                                overflow: 'hidden',
                                //textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                //borderRadius: '0.25rem',
                            }}
                        >
                            {/*{dayEvent.expert}*/}
                            <div
                                // className="flex flex-cols-3"
                                style={{display: 'flex',justifyContent: 'center'}}
                            >
                                <IconButton
                                    // className="control__btn w-5"
                                    // style={{width: '1.25rem',}}
                                    style={{
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '14px',
                                        lineHeight: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        letterSpacing: '-0.0044em',
                                        color: '#214DCE',
                                    }}
                                    onClick={() => {
                                        setDaySelected(day);
                                        setShowEventModal(!isAFreeDay);
                                    }}
                                    // * NEW FEATURE:
                                    //TODO: si la facture n'est pas 'genere', l'expert a tjrs la possibilite de revalider son cra mm si le client l'a valider, et le client de meme peut rejeter un cra qui a ete valider par lui meme si la facture n'est pas 'genere'
                                    disabled={role!='expert'} //|| statutCra == STATUS_CRA?.VC
                                >
                                    {(isAFreeDay && dayEvent.description === '' ? 0 : dayEvent.counter??0)}jr
                                </IconButton>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default Day;